import React from 'react';
import '../template-file-css/document-file-template.css';


export const RRTS_ColumbiaRatingScaleandAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RRTS_ColumbiaRatingScaleandAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <h3>COLUMBIA-SUICIDE SEVERITY RATING SCALE (C-SSRS)

                </h3>
                <h4>Posner, Brent, Lucas, Gould, Stanley, Brown, Fisher, Zelazny, Burke, Oquendo, &amp; Mann
                    &copy; 2008 The Research Foundation for Mental Hygiene, Inc.
                </h4>
                <h4>RISK ASSESSMENT VERSION<br />
                    (<sup>*</sup>elements added with permission for Lifeline centers)
                </h4>
                <p>
                    <strong>Instructions:</strong> Check all risk and protective factors that apply.To be completed following the patient interview, review of medical
                    record(s) and/or consultation with family members and/or other professionals.
                </p>
                <p><span className='eleHeader'>Suicidal and Self-Injury Behavior (Past week)</span></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbActualSuicide" name="cbActualSuicide" className='add-only' value="Actual suicide attempt" />Actual suicide attempt
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbActualSuicide1" name="cbActualSuicide1" className='add-only' value="Lifetime" />Lifetime
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInterrupted" name="cbInterrupted" className='add-only' value="Interrupted attempt" />Interrupted attempt
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInterrupted1" name="cbInterrupted1" className='add-only' value="Lifetime" />Lifetime
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAbortedAttempt" name="cbAbortedAttempt" className='add-only' value="Aborted attempt" />Aborted attempt
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAbortedAttempt1" name="cbAbortedAttempt1" className='add-only' value="Lifetime" />Lifetime
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOtherPreparatory" name="cbOtherPreparatory" className='add-only' value="Other preparatory acts to kill self" />Other preparatory acts to kill self
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOtherPreparatory1" name="cbOtherPreparatory1" className='add-only' value="Lifetime" />Lifetime
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSelfInjury" name="cbSelfInjury" className='add-only' value="Self-injury behavior w/o suicide intent" />Self-injury behavior w/o suicide intent
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSelfInjury1" name="cbSelfInjury1" className='add-only' value="Lifetime" />Lifetime
                        </td>
                    </tr>
                </table>
                <p><span className='eleHeader'>Suicide Ideation (Most Severe in Past Week)</span></p>
                <p>
                    <input type="checkbox" id="cbSuicideIdeation" name="cbSuicideIdeation" className='add-only' value="Wish to be dead" />Wish to be dead
                </p>
                <p>
                    <input type="checkbox" id="cbSuicideIdeation1" name="cbSuicideIdeation1" className='add-only' value="Suicidal thoughts" />Suicidal thoughts
                </p>
                <p>
                    <input type="checkbox" id="cbSuicideIdeation2" name="cbSuicideIdeation2" className='add-only' value="Suicidal thoughts with method (but without specific plan or intent to act)" />Suicidal thoughts with method (but without specific plan or intent to act)
                </p>
                <p>
                    <input type="checkbox" id="cbSuicideIdeation3" name="cbSuicideIdeation3" className='add-only' value="Suicidal intent (without specific plan)" />Suicidal intent (without specific plan)
                </p>
                <p>
                    <input type="checkbox" id="cbSuicideIdeation4" name="cbSuicideIdeation4" className='add-only' value="Suicidal intent with specific plan" />Suicidal intent with specific plan
                </p>
                <p><span className='eleHeader'>Activating Events (Recent)</span></p>
                <p>
                    <input type="checkbox" id="cbActivatingEvents" name="cbActivatingEvents" className='add-only' value="Recent loss or other significant negative event" />Recent loss or other significant negative event
                </p>

                <p>Describe:<textarea id="txtDescribe" name="txtDescribe" className='add-only'></textarea></p>
                <p>
                    <input type="checkbox" id="cbActivatingEvents1" name="cbActivatingEvents1" className='add-only' value="Pending incarceration or homelessness" />Pending incarceration or homelessness
                </p>
                <p>
                    <input type="checkbox" id="cbActivatingEvents2" name="cbActivatingEvents2" className='add-only' value="Current or pending isolation or feeling alone" />Current or pending isolation or feeling alone
                </p>
                <p><span className='eleHeader'>Treatment History</span></p>
                <p>
                    <input type="checkbox" id="cbTreatmentHistory" name="cbTreatmentHistory" className='add-only' value="Previous psychiatric diagnoses and treatments" />Previous psychiatric diagnoses and treatments
                </p>
                <p>
                    <input type="checkbox" id="cbTreatmentHistory1" name="cbTreatmentHistory1" className='add-only' value="Hopeless or dissatisfied with treatment" />Hopeless or dissatisfied with treatment
                </p>
                <p>
                    <input type="checkbox" id="cbTreatmentHistory2" name="cbTreatmentHistory2" className='add-only' value="Noncompliant with treatment" />Noncompliant with treatment
                </p>
                <p>
                    <input type="checkbox" id="cbTreatmentHistory3" name="cbTreatmentHistory3" className='add-only' value="Not receiving treatment" />Not receiving treatment
                </p>
                <p>
                    <span className='eleHeader'>Other Risk Factors</span>
                    <textarea id="txtOtherRiskFactors" name="txtOtherRiskFactors" className='add-only'></textarea>
                </p>
                <p><span className='eleHeader'>Clinical Status (Recent)</span></p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus" name="cbClinicalStatus" className='add-only' value="Hopelessness" />Hopelessness
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus1" name="cbClinicalStatus1" className='add-only' value="Helplessness*" />Helplessness<sup>*</sup>
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus2" name="cbClinicalStatus2" className='add-only' value="Feeling Trapped*" />Feeling Trapped<sup>*</sup>
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus3" name="cbClinicalStatus3" className='add-only' value="Major depressive episode" />Major depressive episode
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus4" name="cbClinicalStatus4" className='add-only' value="Mixed affective episode" />Mixed affective episode
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus5" name="cbClinicalStatus5" className='add-only' value="Command hallucinations to hurt self" />Command hallucinations to hurt self
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus6" name="cbClinicalStatus6" className='add-only' value="Highly impulsive behavior" />Highly impulsive behavior
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus7" name="cbClinicalStatus7" className='add-only' value="Substance abuse or dependence" />Substance abuse or dependence
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus8" name="cbClinicalStatus8" className='add-only' value="Agitation or severe anxiety" />Agitation or severe anxiety
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus9" name="cbClinicalStatus9" className='add-only' value="Perceived burden on family or others" />Perceived burden on family or others
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus10" name="cbClinicalStatus10" className='add-only' value="Chronic physical pain or other acute medical problem" />Chronic physical pain or other acute medical problem (AIDS, COPD, cancer, etc.)
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus11" name="cbClinicalStatus11" className='add-only' value="Homicidal ideation" />Homicidal ideation
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus12" name="cbClinicalStatus12" className='add-only' value="Aggressive behavior towards others" />Aggressive behavior towards others
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus13" name="cbClinicalStatus13" className='add-only' value="Method for suicide available" />Method for suicide available (gun, pills, etc.)
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus14" name="cbClinicalStatus14" className='add-only' value="Refuses or feels unable to agree to safety plan" />Refuses or feels unable to agree to safety plan
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus15" name="cbClinicalStatus15" className='add-only' value="Sexual abuse" />Sexual abuse (lifetime)
                </p>
                <p>
                    <input type="checkbox" id="cbClinicalStatus16" name="cbClinicalStatus16" className='add-only' value="Family history of suicide" />Family history of suicide (lifetime)
                </p>
                <p><span className='eleHeader'>Protective Factors (Recent)</span></p>
                <p>
                    <input type="checkbox" id="cbProtectiveFactors" name="cbProtectiveFactors" className='add-only' value="Identifies reasons for living" />Identifies reasons for living
                </p>
                <p>
                    <input type="checkbox" id="cbProtectiveFactors1" name="cbProtectiveFactors1" className='add-only' value="Responsibility to family or others; living with family" />Responsibility to family or others; living with family
                </p>
                <p>
                    <input type="checkbox" id="cbProtectiveFactors2" name="cbProtectiveFactors2" className='add-only' value="Supportive social network or family" />Supportive social network or family
                </p>
                <p>
                    <input type="checkbox" id="cbProtectiveFactors3" name="cbProtectiveFactors3" className='add-only' value="Fear of death or dying due to pain and suffering" />Fear of death or dying due to pain and suffering
                </p>
                <p>
                    <input type="checkbox" id="cbProtectiveFactors4" name="cbProtectiveFactors4" className='add-only' value="Belief that suicide is immoral high spirituality" />Belief that suicide is immoral, high spirituality
                </p>
                <p>
                    <input type="checkbox" id="cbProtectiveFactors5" name="cbProtectiveFactors5" className='add-only' value="HEngaged in work or school" />Engaged in work or school
                </p>
                <p>
                    <input type="checkbox" id="cbProtectiveFactors6" name="cbProtectiveFactors6" className='add-only' value="Engaged with Phone Worker*" />Engaged with Phone Worker<sup>*</sup>
                </p>
                <p><span className='eleHeader'>Other Protective Factors</span><textarea id="txtOtherProtectiveFactors" name="txtOtherProtectiveFactors" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>Describe any suicidal, self-injury or aggressive behavior (include dates):</span>
                    <textarea id="txtSuicidalBehavior" name="txtSuicidalBehavior" className='add-only'></textarea>
                </p>
                <p><span className='eleHeader'>SUICIDAL IDEATION</span></p>
                <p>
                    Ask questions 1 and 2. If both are negative, proceed to "Suicidal Behavior" section. If the answer to
                    question 2 is "yes", ask questions 3, 4 and 5. If the answer to question 1 and/or 2 is "yes", complete
                    "Intensity of Ideation" section below.
                </p>
                <h3>1. Wish to be Dead</h3>
                <p>
                    Subject endorses thoughts about a wish to be dead or not alive anymore, or wish to fall asleep and not wake up.<br />
                    <strong>Have you wished you were dead or wished you could go to sleep and not wake up?</strong>
                </p>
                <p>
                    <input type="radio" id="rbWish_Yes" name="rbWish" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbWish_No" name="rbWish" className='add-only' value="0" /> No &nbsp;
                    If yes, describe:<textarea id="txtWishDead" name="txtWishDead" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime: Time He/She Felt Most Suicidal</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 1 month</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime_Yes" name="rbLifetime" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime_No" name="rbLifetime" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast_Yes" name="rbPast" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast_No" name="rbPast" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>
                <h3>2. Non-Specific Active Suicidal Thoughts</h3>
                <p>
                    General non-specific thoughts of wanting to end one`s life/commit suicide (e.g.,"I`ve thought about killing myself") without thoughts
                    of ways to kill oneself/associated methods, intent, or plan during the assessment period.<br />
                    <strong>Have you actually had any thoughts of killing yourself?</strong>
                </p>
                <p>
                    <input type="radio" id="rbNonSpecific_Yes" name="rbNonSpecific" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbNonSpecific_No" name="rbNonSpecific" className='add-only' value="0" /> No &nbsp;
                    If yes, describe:<textarea id="txtSuicidalThoughts" name="txtSuicidalThoughts" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime: Time He/She Felt Most Suicidal</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 1 month</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime1_Yes" name="rbLifetime1" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime1_No" name="rbLifetime1" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast1_Yes" name="rbPast1" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast1_No" name="rbPast1" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <h3>3. Active Suicidal Ideation with Any Methods (Not Plan) without Intent to Act</h3>
                <p>
                    Subject endorses thoughts of suicide and has thought of at least one method during the assessment period. This is different than a
                    specific plan with time, place or method details worked out (e.g., thought of method to kill self but not a specific plan). Includes person
                    who would say,"I thought about taking an overdose but I never made a specific plan as to when, where or how I would actually do
                    it.....and I would never go throughwith it."
                    <br />
                    <strong>Have you been thinking about how you might do this?</strong>
                </p>
                <p>
                    <input type="radio" id="rbNonSpecific1_Yes" name="rbNonSpecific1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbNonSpecific1_No" name="rbNonSpecific1" className='add-only' value="0" /> No &nbsp;
                    If yes, describe:<textarea id="txtSuicidalDate1" name="txtSuicidalDate1" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime: Time He/She Felt Most Suicidal</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 1 month</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime2_Yes" name="rbLifetime2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime2_No" name="rbLifetime2" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast2_Yes" name="rbPast2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast2_No" name="rbPast2" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <h3>4. Active Suicidal Ideation with Some Intent to Act, without Specific Plan</h3>
                <p>
                    Active suicidal thoughts of killing oneself and subject reports having some intent to act on such thoughts, as opposed to "I have the
                    thoughts but I definitely will not do anything about them."
                    <br />
                    <strong>Have you had these thoughts and had some intention of acting on them?</strong>
                </p>
                <p>
                    <input type="radio" id="rbNonSpecific2_Yes" name="rbNonSpecific2" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbNonSpecific2_No" name="rbNonSpecific2" className='add-only' value="0" /> No &nbsp;
                    If yes, describe:<textarea id="txtSuicidalDate2" name="txtSuicidalDate2" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime: Time He/She Felt Most Suicidal</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 1 month</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime3_Yes" name="rbLifetime3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime3_No" name="rbLifetime3" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast3_Yes" name="rbPast3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast3_No" name="rbPast3" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <h3>5. Active Suicidal Ideation with Specific Plan and Intent</h3>
                <p>
                    Thoughts of killing oneself with details of plan fully or partially worked out and subject has some intent to carry it out.<br />
                    <strong>Have you started to work out or worked out the details of how to kill yourself? Do you intend to carry out this plan?</strong>
                </p>
                <p>
                    <input type="radio" id="rbNonSpecific3_Yes" name="rbNonSpecific3" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbNonSpecific3_No" name="rbNonSpecific3" className='add-only' value="0" /> No &nbsp;
                    If yes, describe:<textarea id="txtSuicidalDate3" name="txtSuicidalDate3" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime: Time He/She Felt Most Suicidal</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 1 month</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime4_Yes" name="rbLifetime4" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime4_No" name="rbLifetime4" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast4_Yes" name="rbPast4" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast4_No" name="rbPast4" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <p><span className='eleHeader'>INTENSITY OF IDEATION</span></p>
                <p>
                    The following features should be rated with respect to the most severe type of ideation (i.e., 1-5 from above, with 1 being the least severe and 5 being the most severe). Ask about time he/she was feeling the most suicidal.
                </p>
                <p>Lifetime - <strong>Most Severe Ideation: Type # (1-5) </strong>
                    <input type="text" id="txtMostSevereIdeation" name="txtMostSevereIdeation" className='add-only' /></p>
                <p>Description of Ideation<textarea id="txtDescription" name="txtDescription" className='add-only'></textarea></p>
                <p>Recent - <strong>Most Severe Ideation: Type # (1-5) </strong>
                    <input type="text" id="txtMostSevereIdeation1" name="txtMostSevereIdeation1" className='add-only' /></p>
                <p>Description of Ideation<textarea id="txtDescription1" name="txtDescription1" className='add-only'></textarea></p>
                <p>
                    <strong>Frequency<br />
                        How many times have you had these thoughts?
                    </strong>
                </p>
                <p>
                    <input type="radio" id="rbFrequency_1" name="rbFrequency" className='add-only' value="1" />(1) Less than once a week
                    <input type="radio" id="rbFrequency_2" name="rbFrequency" className='add-only' value="2" />(2) Once a week
                    <input type="radio" id="rbFrequency_3" name="rbFrequency" className='add-only' value="3" />(3) 2-5 times in week
                    <input type="radio" id="rbFrequency_4" name="rbFrequency" className='add-only' value="4" />(4) Daily or almost daily
                </p>
                <p>
                    <input type="radio" id="rbFrequency_5" name="rbFrequency" className='add-only' value="5" />(5) Many times each day
                </p>
                <table>
                    <tr>
                        <td className='w-375'>Most Severe</td>
                        <td className='w-375'>Most Severe</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere" name="txtMostSevere" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere1" name="txtMostSevere1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Duration
                        <br />
                        When you have the thoughts how long do they last?
                    </strong>
                </p>
                <p>
                    <input type="radio" id="rbDuration_1" name="rbDuration" className='add-only' value="1" />(1) Fleeting-few seconds or minutes
                    <input type="radio" id="rbDuration_2" name="rbDuration" className='add-only' value="2" />(2) Less than 1 hour/some of the time
                    <input type="radio" id="rbDuration_3" name="rbDuration" className='add-only' value="3" />(3) 1-4 hours/a lot of time
                </p>
                <p>
                    <input type="radio" id="rbDuration_4" name="rbDuration" className='add-only' value="4" />
                    (4) 4-8 hours/most of day
                    <input type="radio" id="rbDuration_5" name="rbDuration" className='add-only' value="5" />(5) More than 8 hours/persistent or continuous
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Most Severe</span></td>
                        <td className='w-375'><span className='eleHeader'>Most Severe</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere2" name="txtMostSevere2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere3" name="txtMostSevere3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Controllability<br />
                        Could/can you stop thinking about killing yourself or wanting to die if you want to?
                    </strong>
                </p>
                <p>
                    <input type="radio" id="rbControllability_1" name="rbControllability" className='add-only' value="1" />(1) Easily able to control thoughts
                    <input type="radio" id="rbControllability_2" name="rbControllability" className='add-only' value="2" />(2) Can control thoughts with little difficulty
                </p>
                <p>
                    <input type="radio" id="rbControllability_3" name="rbControllability" className='add-only' value="3" />(3) Can control thoughts with some difficulty
                    <input type="radio" id="rbControllability_4" name="rbControllability" className='add-only' value="4" />
                    (4) Can control thoughts with a lot of difficulty
                </p>
                <p>
                    <input type="radio" id="rbControllability_5" name="rbControllability" className='add-only' value="5" />(5) Unable to control thoughts
                    <input type="radio" id="rbControllability_6" name="rbControllability" className='add-only' value="6" />(0) Does not attempt to control thoughts
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Most Severe</span></td>
                        <td className='w-375'><span className='eleHeader'>Most Severe</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere4" name="txtMostSevere4" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere5" name="txtMostSevere5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Deterrents<br />
                        Are there things - anyone or anything (e.g., family, religion, pain of death) - that stopped you from wanting to
                        die or acting on thoughts of committing suicide?
                    </strong>
                </p>
                <p>
                    <input type="radio" id="rbDeterrents_1" name="rbDeterrents" className='add-only' value="1" />(1) Deterrents definitely stopped you from attempting suicide
                    <input type="radio" id="rbDeterrents_2" name="rbDeterrents" className='add-only' value="2" />(2) Deterrents probably stopped you
                </p>
                <p>
                    <input type="radio" id="rbDeterrents_3" name="rbDeterrents" className='add-only' value="3" />(3) Uncertain that deterrents stopped you
                    <input type="radio" id="rbDeterrents_4" name="rbDeterrents" className='add-only' value="4" />(4) Deterrents most likely did not stop you

                </p>
                <p>
                    <input type="radio" id="rbDeterrents_5" name="rbDeterrents" className='add-only' value="5" />(5) Deterrents definitely did not stop you
                    <input type="radio" id="rbDeterrents_6" name="rbDeterrents" className='add-only' value="6" />(0) Does not apply
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Most Severe</span></td>
                        <td className='w-375'><span className='eleHeader'>Most Severe</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere6" name="txtMostSevere6" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere7" name="txtMostSevere7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Reasons for Ideation<br />
                        What sort of reasons did you have for thinking about wanting to die or killing yourself? Was it to end the pain
                        or stop the way you were feeling (in other words you couldn`t go on living with this pain or how you were
                        feeling) or was it to get attention, revenge or a reaction from others? Or both?
                    </strong>
                </p>
                <p>
                    <input type="radio" id="rbIdeation_1" name="rbIdeation" className='add-only' value="1" />(1) Completely to get attention, revenge or a reaction from others
                </p>
                <p>
                    <input type="radio" id="rbIdeation_2" name="rbIdeation" className='add-only' value="2" />(2) Mostly to get attention, revenge or a reaction from others
                </p>
                <p>
                    <input type="radio" id="rbIdeation_3" name="rbIdeation" className='add-only' value="3" />(3) Equally to get attention, revenge or a reaction from others and to end/stop the pain
                </p>
                <p>
                    <input type="radio" id="rbIdeation_4" name="rbIdeation" className='add-only' value="4" />
                    (4) Mostly to end or stop the pain (you couldn t go on living with the pain or how you were feeling)
                </p>
                <p>
                    <input type="radio" id="rbIdeation_5" name="rbIdeation" className='add-only' value="5" />(5) Completely to end or stop the pain (you couldn`t go on living with the pain or how you were feeling)
                </p>
                <p>
                    <input type="radio" id="rbIdeation_6" name="rbIdeation" className='add-only' value="6" />(0) Does not apply
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Most Severe</span></td>
                        <td className='w-375'><span className='eleHeader'>Most Severe</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere8" name="txtMostSevere8" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtMostSevere9" name="txtMostSevere9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>SUICIDAL BEHAVIOR</span>
                    <span className='small'>(Check all that apply, so long as these are separate events; must ask about all types)</span>
                </p>
                <p><strong>Actual Attempt:</strong></p>
                <p>
                    A potentially self-injurious act committed with at least some wish to die, as a result of act. Behavior was in part thought of as method to kill
                    oneself. Intent does not have to be 100%. If there is any intent/desire to die associated with the act, then it can be considered an actual suicide
                    attempt. There does not have to be any injury or harm, just the potential for injury or harm. If person pulls trigger while gun is in
                    mouth but gun is broken so no injury results, this is considered an attempt.
                    <br />
                    Inferring Intent: Even if an individual denies intent/wish to die, it may be inferred clinically from the behavior or circumstances. For example, a
                    highly lethal act that is clearly not an accident so no other intent but suicide can be inferred (e.g., gunshot to head, jumping from window of a
                    high floor/story). Also, if someone denies intent to die, but they thought that what they did could be lethal, intent may be inferred.
                </p>
                <p><strong>Have you made a suicide attempt?</strong></p>
                <p>
                    <input type="radio" id="rbSuicide_Yes" name="rbSuicide" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSuicide_No" name="rbSuicide" className='add-only' value="0" /> No &nbsp;
                </p>
                <p><strong>Have you done anything to harm yourself?</strong></p>
                <p>
                    <input type="radio" id="rbSuicide1_Yes" name="rbSuicide1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSuicide1_No" name="rbSuicide1" className='add-only' value="0" /> No &nbsp;
                </p>
                <p><strong>Have you done anything dangerous where you could have died?</strong></p>
                <p>
                    <input type="radio" id="rbSuicide2_Yes" name="rbSuicide2" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSuicide2_No" name="rbSuicide2" className='add-only' value="0" /> No &nbsp;
                </p>
                <p>
                    <strong>What did you do?
                    <input type="text" id="txtActualAttempt" name="txtActualAttempt" className='add-only w-250 custom-add-only' /></strong></p>
                <p>
                    <strong>Did you
                    <input type="text" id="txtActualAttempt1" name="txtActualAttempt1" className='add-only w-250 custom-add-only' /> as a way to end your life?</strong></p>
                <p>
                    <strong>Did you want to die (even a little) when you
                    <input type="text" id="txtActualAttempt2" name="txtActualAttempt2" className='add-only w-250 custom-add-only' /> ?</strong></p>
                <p>
                    <strong>Were you trying to end your life when you
                    <input type="text" id="txtActualAttempt3" name="txtActualAttempt3" className='add-only w-250 custom-add-only' /> ?</strong></p>
                <p>
                    <strong>Or Did you think it was possible you could have died from
                    <input type="text" id="txtActualAttempt4" name="txtActualAttempt4" className='add-only w-250 custom-add-only' /> ? </strong></p>
                <p>
                    <strong>Or did you do it purely for other reasons/without ANY intention of killing yourself (like to relieve stress, feel better, get sympathy, or get something else to happen)?
                    </strong><span className='small'>(Self-Injurious Behavior without suicidal intent)</span>
                </p>
                <p>If yes, describe:<textarea id="txtSuicidalDate4" name="txtSuicidalDate4" className='add-only'></textarea></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime5_Yes" name="rbLifetime5" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime5_No" name="rbLifetime5" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast5_Yes" name="rbPast5" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast5_No" name="rbPast5" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Total # of Attempts</td>
                        <td className='w-375'>Total # of Attempts</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtAttempts" name="txtAttempts" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtAttempts1" name="txtAttempts1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>Has subject engaged in Non-Suicidal Self-Injurious Behavior?</strong></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime6_Yes" name="rbLifetime6" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime6_No" name="rbLifetime6" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast6_Yes" name="rbPast6" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast6_No" name="rbPast6" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>
                <p><strong>Interrupted Attempt:</strong></p>
                <p>
                    When the person is interrupted (by an outside circumstance) from starting the potentially self-injurious act (if not for that, actual attempt would have occurred).
                    <br />
                    Overdose: Person has pills in hand but is stopped from ingesting. Once they ingest any pills, this becomes an attempt rather than an interrupted
                    attempt. Shooting: Person has gun pointed toward self, gun is taken away by someone else, or is somehow prevented from pulling trigger. Once
                    they pull the trigger, even if the gun fails to fire, it is an attempt. Jumping: Person is poised to jump, is grabbed and taken down from ledge.
                    Hanging: Person has noose around neck but has not yet started to hang - is stopped from doing so.
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime7_Yes" name="rbLifetime7" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime7_No" name="rbLifetime7" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast7_Yes" name="rbPast7" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast7_No" name="rbPast7" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Has there been a time when you started to do something to end your life but someone or something stopped you before
                        you actually did anything?
                    </strong>
                </p>
                <p>If yes, describe:<textarea id="txtSuicidalDate12" name="txtSuicidalDate12" className='add-only'></textarea></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Total # of interrupted</td>
                        <td className='w-375'>Total # of interrupted</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtInterrupted" name="txtInterrupted" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtInterrupted1" name="txtInterrupted1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>Aborted or Self-Interrupted Attempt:</strong></p>
                <p>
                    When person begins to take steps toward making a suicide attempt, but stops themselves before they actually have engaged in any selfdestructive
                    behavior. Examples are similar to interrupted attempts, except that the individual stops him/herself, instead of being stopped by
                    something else.
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime8_Yes" name="rbLifetime8" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime8_No" name="rbLifetime8" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast8_Yes" name="rbPast8" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast8_No" name="rbPast8" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Has there been a time when you started to do something to try to end your life but you stopped yourself before you
                        actually did anything?
                    </strong>
                </p>
                <p>If yes, describe:<textarea id="txtSuicidalDate13" name="txtSuicidalDate13" className='add-only'></textarea></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Total # of aborted or selfinterrupted</td>
                        <td className='w-375'>Total # of aborted or selfinterrupted</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtSelfInterrupted" name="txtSelfInterrupted" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtSelfInterrupted1" name="txtSelfInterrupted1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>Preparatory Acts or Behavior:</strong></p>
                <p>
                    Acts or preparation towards imminently making a suicide attempt. This can include anything beyond a verbalization or thought, such as
                    assembling a specific method (e.g., buying pills, purchasing a gun) or preparing for one`s death by suicide (e.g., giving things away, writing a
                    suicide note).
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbLifetime9_Yes" name="rbLifetime9" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbLifetime9_No" name="rbLifetime9" className='add-only' value="0" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbPast9_Yes" name="rbPast9" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbPast9_No" name="rbPast9" className='add-only' value="0" /> No &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Have you taken any steps towards making a suicide attempt or preparing to kill yourself (such as collecting pills,
                        getting a gun, giving valuables away or writing a suicide note)?
                    </strong>
                </p>
                <p>If yes, describe:<textarea id="txtSuicidalDate14" name="txtSuicidalDate14" className='add-only'></textarea></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Lifetime</span> </td>
                        <td className='w-375'><span className='eleHeader'>Past 3 months</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Total # of preparatory acts </td>

                        <td className='w-375'>Total # of preparatory acts</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPreparatory" name="txtPreparatory" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtPreparatory1" name="txtPreparatory1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>Actual Lethality/Medical Damage:</strong></p>
                <p>
                    0. No physical damage or very minor physical damage (e.g., surface scratches).
                </p>
                <p>
                    1. Minor physical damage (e.g., lethargic speech; first-degree burns; mild bleeding; sprains).
                </p>
                <p>
                    2. Moderate physical damage; medical attention needed (e.g., conscious but sleepy, somewhat responsive; second-degree burns; bleeding of major vessel).
                </p>
                <p>
                    3. Moderately severe physical damage; medical hospitalization and likely intensive care required (e.g., comatose with reflexes
                    intact; third-degree burns less than 20% of body; extensive blood loss but can recover; major fractures).
                </p>
                <p>
                    4. Severe physical damage; medical hospitalization with intensive care required (e.g., comatose without reflexes; third-degree
                    burns over 20% of body; extensive blood loss with unstable vital signs; major damage to a vital area).
                </p>
                <p>
                    5. Death
                </p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Most Recent Attempt Date:</span> </td>
                        <td className='w-250'><span className='eleHeader'>Most Lethal Attempt Date:</span> </td>
                        <td className='w-250'><span className='eleHeader'>Initial/First Attempt Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtAttemptDate" name="txtAttemptDate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtAttemptDate1" name="txtAttemptDate1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtAttemptDate2" name="txtAttemptDate2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><strong>Enter Code</strong></td>
                        <td className='w-250'><strong>Enter Code</strong></td>
                        <td className='w-250'><strong>Enter Code</strong></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtEnterCode" name="txtEnterCode" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtEnterCode1" name="txtEnterCode1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtEnterCode2" name="txtEnterCode2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>Potential Lethality: Only Answer if Actual Lethality=0</strong></p>
                <p>
                    Likely lethality of actual attempt if no medical damage (the following examples, while having no actual medical damage, had
                    potential for very serious lethality: put gun in mouth and pulled the trigger but gun fails to fire so no medical damage; laying
                    on train tracks with oncoming train but pulled away before run over).
                </p>
                <p>
                    0 = Behavior not likely to result in injury
                </p>
                <p>
                    1 = Behavior likely to result in injury but not likely to cause death
                </p>
                <p>
                    2 = Behavior likely to result in death despite available medical care
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Most Recent Attempt Date:</span> </td>
                        <td className='w-250'><span className='eleHeader'>Most Lethal Attempt Date:</span> </td>
                        <td className='w-250'><span className='eleHeader'>Initial/First Attempt Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtAttemptDate3" name="txtAttemptDate3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtAttemptDate4" name="txtAttemptDate4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtAttemptDate5" name="txtAttemptDate5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><strong>Enter Code</strong></td>
                        <td className='w-250'><strong>Enter Code</strong></td>
                        <td className='w-250'><strong>Enter Code</strong></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtEnterCode3" name="txtEnterCode3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtEnterCode4" name="txtEnterCode4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtEnterCode5" name="txtEnterCode5" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Interpretative Summary and Recommendations</span>

                    <textarea id="txtRecommendations" name="txtRecommendations" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Completed by:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-400'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='small w-400'>Staff Name/Position:</td>
                        <td className='small w-200'>Clinician`s Signature:</td>
                        <td className='small w-150'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-400'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='small w-400'>Reviewed by:</td>
                        <td className='small w-200'>Reviewer`s Signature:</td>
                        <td className='small w-150'>Date:</td>
                    </tr>
                </table>

            </div>
        </form>

    )
}   